import { useEffect, useMemo } from 'react';
import { customSignupFormRules } from 'helpers/customFormRules';

import { btag, pushToDataLayer } from '@atlas/core';
import { FIELD_COMPONENTS } from '@atlas/react-forms';

import { EMAIL_SIGNUP } from 'common/Form/Fields/EmailField/constants';

import { changeAsyncToDeferRules } from './change-async-to-defer-rules';

const { COMPLEX_PASSWORD, PASSWORD } = FIELD_COMPONENTS;

const useStepFields = ({ form, stepNumber }) => {
  const fields = useMemo(() => {
    const stepFields = form?.steps[stepNumber]?.fields ?? [];

    const names = stepFields.map(field => field.name);
    const autocompleteForEmailAndPhone = names.includes('EMAIL') ? 'do-not-autofill' : 'off';
    const isPasswordField = field => {
      return [PASSWORD, COMPLEX_PASSWORD].includes(field.component) || /password/i.test(field.name);
    };
    const resolveAutoComplete = field => {
      if (isPasswordField(field)) return 'off';
      if (['EMAIL', 'PHONE'].includes(field.name)) return autocompleteForEmailAndPhone;
      return 'off';
    };

    const resolveComponent = field => {
      if (field.name === 'EMAIL') return EMAIL_SIGNUP;
      return field.component;
    };

    return stepFields.map(field => ({
      ...field,
      autocomplete: resolveAutoComplete(field),
      isTypeText: isPasswordField(field),
      ...customSignupFormRules(field),
      ...changeAsyncToDeferRules(field),
      component: resolveComponent(field),
    }));
  }, [stepNumber, form]);

  useEffect(() => {
    if (fields.length === 1 && fields[0].component === 'SMS_CODE') {
      pushToDataLayer('OTP_requested', btag);
    }
  }, [fields]);

  return fields;
};

export default useStepFields;
